/* eslint-disable max-len */
/**
 * Video Data Transformer
 * Transforms the nested API response structure to the flat structure expected by VideoDetailsSlider
 */

export const transformVideoDataForSlider = (contentData: any) =>
{
	if (!contentData || !contentData.videos || !contentData.videos[0])
	{
		return null;
	}

	const video = contentData.videos[0];

	return {
		// From videos[0] - video specific data
		id          : contentData._id,
		title       : video.title || '',
		description : video.description || '',
		url         : video.url || '',
		thumbnail   : video.thumbnail || null,
		status      : video.status?.toLowerCase() || '',
		fileType    : video.fileType || '',
		fileSize    : video.fileSize || 0,
		duration    : video.duration || 0,

		// From top level - content collection data
		categoryIds   : contentData.categoryIds || [],
		categories    : contentData.categoryIds || [], // VideoDetailsSlider uses both
		tags          : contentData.tags || [],
		playlists     : video.playlists || [],
		accessControl : contentData.accessControl || {},

		// Default values for missing properties
		visibility    : contentData?.visibility?.toLowerCase() ?? '', // Default since not in response
		allowDownload : contentData?.allowDownload ?? false, // Default since not in response  
		allowShare    : contentData?.allowShare ?? false, // Default since not in response

		// Additional metadata
		engagement     : contentData.engagement || {},
		createdBy      : contentData.createdBy || {},
		videoCreatedAt : contentData.videoCreatedAt,
		videoUpdatedAt : contentData.videoUpdatedAt,
		publishedAt    : contentData.publishedAt, // Add publishedAt field
		// publishDate    : contentData.publishedAt, // Add publishDate field for compatibility

		// Keep original for reference
		originalData : contentData
	};
};